




































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import OpenDataComponent from '@/components/openData.vue';
import moment from 'moment';
import { getNumber } from '@/helpers';
import { idbService } from '@/services';

@Component({
  components: {
    OpenDataComponent
  }
})
export default class ProjectCreateComponent extends Vue {
  lookup = this.$store.state.lookup;
  account = this.$store.state.account;
  activeStep = 0;
  projectModel = {
    idbId: 1,
    state: { key: '02' },
    provider: { key: '' },
    providerSubject: {},
    grantProgram: { key: '' },
    role: {},
    responsibleFaculty: {},
    solver: { key: '' },
    otherSolvers: [],
    isNonResearchProject: false,
    category: {},
    mainFieldGroup: { key: '' },
    mainField: { key: '' },
    studyProgram: {},
    socioEconomicBenefitPrimaryArea: '',
    predominantFundingSource: {},
    projectType: {},
    secondaryField: {},
    otherField: {},
    coordinator: null,
    budget: {
      //eligibleProjectExpenditure: null,
      budget: null,
      grantAmount: null,
      coFinancingPublicSourcesAmount: null,
      coFinancingNonPublicSourcesAmount: null,
      shareOfInvestmentCosts: null,
      currencyCode: 'CZK'
    },
    startedOn: null,
    endedOn: null
  };
  loadedLookups = [];
  window = 0;
  startedOnOpen = false;
  endedOnOpen = false;
  grantContractSignDateOpen = false;
  documentationArchivedTilOpen = false;
  requiredRule = [(v: any) => !!v || this.$t('project.error.requiredField')];
  isCoordinatorFocused = false;
  autocompleteSearch = '';
  steps = {
    step1: {
      focused: false,
      valid: true
    },
    step2: {
      focused: false,
      valid: true
    },
    step3: {
      focused: false,
      valid: true
    },
    step4: {
      focused: false,
      valid: true
    },
    step5: {
      focused: false,
      valid: true
    }
  };

  async beforeCreate() {
    const savedProject = (await idbService.getProject()) as any;

    if (savedProject !== undefined) {
      this.projectModel = savedProject;
    }
  }

  get startedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.projectModel.endedOn || moment(value) <= moment(this.projectModel.endedOn) || this.$t('project.error.startedOn')
    ];
  }

  get endedOnValidation() {
    return [
      (value: string) => (value !== null && value !== '') || this.$t('project.error.requiredField'),
      (value: string) => !this.projectModel.startedOn || moment(value) >= moment(this.projectModel.startedOn) || this.$t('project.error.endedOn')
    ];
  }

  get budgetValidation() {
    return [(value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField')];
  }

  get grantAmountValidation() {
    const budget = this.projectModel.budget;

    return [
      (value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField'),
      (value: string) => (getNumber(value) >= 0 && getNumber(value) <= (budget.budget || 0)) || this.$t('project.error.grantAmountValidation')
    ];
  }

  get coFinancingPublicValidation() {
    const budget = this.projectModel.budget;

    return [
      (value: string) => (value !== null && value !== '' && getNumber(value) >= 0) || this.$t('project.error.requiredField'),
      (value: string) => getNumber(value) <= Number(((budget.budget || 0) - (budget.grantAmount || 0)).toFixed(2)) || this.$t('project.error.coFinancingPublicValidation')
    ];
  }

  get shareOfInvestmentCostsValidation() {
    const budget = this.projectModel.budget;

    return [
      (value: string) => value !== '' || this.$t('project.error.requiredField'),
      (value: string) => getNumber(value) <= (budget.budget || 0) || this.$t('project.error.shareOfInvestmentCostsValidation')
    ];
  }

  async loadItems(id: number) {
    this.$store.dispatch('lookup/getAvailableLookup', id);
  }

  items(id: number) {
    this.$store.getters['lookup/getAvailableLookupDetail'](id);
  }

  getLookup(id: number) {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](id);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  getFacultyLookup() {
    return this.account.user.user.role === 'Administrator'
      ? this.getLookup(6)
      : this.getLookup(6).filter((lookupItem: any) => this.account.user.user.faculties?.find((item: any) => item.facultyId === lookupItem.id));
  }

  get getMainFieldLookup() {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](9);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .filter((i: any) => !(this.projectModel.mainFieldGroup as any).key || (this.projectModel.mainFieldGroup as any).key === i.referenceKey)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  get getGrantProgramLookup() {
    const lookup = this.$store.getters['lookup/getAvailableLookupDetail'](4);
    return lookup
      .filter((item: any) => !item.isDisabled)
      .filter((i: any) => !(this.projectModel.provider as any).key || (this.projectModel.provider as any).key === i.referenceKey)
      .sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  get isFormValid() {
    return (
      this.steps.step1.focused &&
      this.steps.step1.valid &&
      this.steps.step2.focused &&
      this.steps.step2.valid &&
      this.steps.step3.focused &&
      this.steps.step3.valid &&
      this.steps.step4.focused &&
      this.steps.step4.valid &&
      this.steps.step5.focused &&
      this.steps.step5.valid
    );
  }

  get projectDuration() {
    if (this.projectModel.endedOn && this.projectModel.startedOn) {
      const a = moment(this.projectModel.endedOn);
      const b = moment(this.projectModel.startedOn);

      const years = a.diff(b, 'year');
      b.add(years, 'years');

      const months = a.diff(b, 'months');
      b.add(months, 'months');

      const days = a.diff(b, 'days');

      return {
        years: years,
        months: months,
        days: days
      };
    } else {
      return {
        years: '-',
        months: '-',
        days: '-'
      };
    }
  }

  getFormatedDate(date: Date) {
    return date ? moment(date).format('DD.MM.YYYY') : '';
  }

  getGrantAmountPercentage() {
    (this.projectModel.budget as any).grantAmountPercentage = Math.round(((this.projectModel.budget as any).grantAmount / (this.projectModel.budget as any).budget) * 100);
    return (this.projectModel.budget as any).grantAmountPercentage;
  }

  getCoFinancingPublicSourcesPercentage() {
    (this.projectModel.budget as any).coFinancingPublicSourcesPercentage = Math.round(
      ((this.projectModel.budget as any).coFinancingPublicSourcesAmount / (this.projectModel.budget as any).budget) * 100
    );
    return (this.projectModel.budget as any).coFinancingPublicSourcesPercentage;
  }

  getCoFinancingNonPublicSourcesPercentage() {
    const budget = this.projectModel.budget as any;

    budget.coFinancingNonPublicSourcesPercentage = Math.round((budget.coFinancingNonPublicSourcesAmount / budget.budget) * 100);
    return budget.coFinancingNonPublicSourcesPercentage;
  }

  getCoFinancingNonPublicSourcesAmount() {
    const budget = this.projectModel.budget as any;

    budget.coFinancingNonPublicSourcesAmount = Number((Number(budget.budget) - Number(budget.grantAmount) - Number(budget.coFinancingPublicSourcesAmount)).toFixed(2));
    return budget.coFinancingNonPublicSourcesAmount;
  }

  getTotalCoFinancing() {
    const budget = this.projectModel.budget as any;
    budget.totalCoFinancing = Number(budget.coFinancingPublicSourcesAmount) + Number(budget.coFinancingNonPublicSourcesAmount);
    return budget.totalCoFinancing;
  }

  getShareOfNonInvestmentCosts() {
    const budget = this.projectModel.budget as any;
    budget.shareOfNonInvestmentCosts = Number((budget.budget - budget.shareOfInvestmentCosts).toFixed(2));
    return (this.projectModel.budget as any).shareOfNonInvestmentCosts;
  }

  handleCreateSubmit() {
    (this.$refs.step5 as any).validate();
    this.steps.step5.focused = true;

    if (this.isFormValid) {
      const newProject = this.projectModel;
      idbService.deleteProject();
      this.$store.dispatch('project/createProject', { newProject });
    }
  }

  resetForm() {
    idbService.deleteProject();
    this.$router.push('/');
  }

  remove(item: any) {
    const index = (this.projectModel.otherSolvers as any).indexOf(item.id);
    if (index >= 0) this.projectModel.otherSolvers.splice(index, 1);
  }

  customSolverFilter(item: any, queryText: string, itemText: string) {
    const userName = item.userName.toLowerCase();
    const firstName = item.firstName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const lastName = item.lastName
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const searchText = queryText
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return userName.indexOf(searchText) > -1 || firstName?.indexOf(searchText) > -1 || lastName?.indexOf(searchText) > -1;
  }

  get facultyId() {
    return (this.projectModel.responsibleFaculty as any).key;
  }

  get visibleState() {
    const state = (this.projectModel.state as any).key;

    return state === '04' || state === '05' || state === '06';
  }

  get isSustainable() {
    return (this.projectModel as any).isSustainable;
  }

  get mainField() {
    return (this.projectModel.mainField as any).key;
  }

  get mainFieldGroup() {
    return (this.projectModel.mainFieldGroup as any).key;
  }

  get grantProgram() {
    return (this.projectModel.grantProgram as any).key;
  }

  get provider() {
    return (this.projectModel.provider as any).key;
  }

  get budget() {
    return this.projectModel.budget.budget;
  }

  @Watch('visibleState')
  onStateChanged(value: string, oldValue: string) {
    if (!value) {
      const project = this.projectModel as any;
      project.registrationNumber = '';
      project.contractNumber = '';
    }
  }

  @Watch('isSustainable')
  onSustainableChanged(value: string, oldValue: string) {
    if (!value) {
      (this.projectModel as any).sustainabilityDuration = '';
    }
  }

  @Watch('mainField')
  onMainFieldChanged(value: any, oldValue: string) {
    const item = this.getLookup(9).find((item: any) => item.key === value);

    if (item) {
      this.loadItems(8);
      (this.projectModel.mainFieldGroup as any).key = item.referenceKey;
    }
  }

  @Watch('mainFieldGroup')
  onMainFieldGroupChanged(value: any, oldValue: string) {
    if (oldValue !== '') {
      (this.projectModel.mainField as any).key = '';
    }
  }

  @Watch('grantProgram')
  onGrantProgramChanged(value: any, oldValue: string) {
    const item = this.getLookup(4).find((item: any) => item.key === value);

    if (item) {
      this.loadItems(2);
      (this.projectModel.provider as any).key = item.referenceKey;
    }
  }

  @Watch('provider')
  onProviderChanged(value: any, oldValue: string) {
    if (oldValue !== '') {
      (this.projectModel.grantProgram as any).key = '';
    }
  }

  @Watch('window')
  onStepChanged(value: any, oldValue: any) {
    if (oldValue === 0) {
      (this.$refs.step1 as any).validate();
      this.steps.step1.focused = true;
    }
    if (oldValue === 1) {
      (this.$refs.step2 as any).validate();
      this.steps.step2.valid = this.projectModel.coordinator !== undefined && this.projectModel.coordinator !== null;
      this.isCoordinatorFocused = true;
      this.steps.step2.focused = true;
    }
    if (oldValue === 2) {
      (this.$refs.step3 as any).validate();
      this.steps.step3.focused = true;
    }
    if (oldValue === 3) {
      (this.$refs.step4 as any).validate();
      this.steps.step4.focused = true;
    }
    if (oldValue === 4) {
      (this.$refs.step5 as any).validate();
      this.steps.step5.focused = true;
    }
  }

  @Watch('projectModel', { deep: true })
  dataChanged() {
    idbService.saveProject(this.projectModel);
  }

  @Watch('facultyId')
  onFacultyChanged(value: any, oldValue: any) {
    if (value && value !== null) {
      const faculty = this.getLookup(6).find((item: any) => item.key === value);

      if (faculty) {
        this.$store.dispatch('account/getSolvers', faculty.id);
      }
    }
  }

  @Watch('budget')
  budgetChanged(value: any) {
    if (value === 0) {
      this.projectModel.budget.grantAmount = 0 as any;
      this.projectModel.budget.coFinancingPublicSourcesAmount = 0 as any;
      this.projectModel.budget.shareOfInvestmentCosts = 0 as any;
    }
  }
}
